export default {
  data: function() {
    return {
      error: null,
    }
  },
  computed: {
    hasErrors() {
      return !!this.error
    },
  },
  methods: {
    clearErrors() {
      this.error = null
    },
    setErrors(errorObj, scrollToTop = false) {
      this.error = errorObj

      if (scrollToTop)
        // Scroll to top of page to display error
        this.$vuetify.goTo('#ownpool-app', {
          duration: 500,
          offset: 0,
          easing: 'easeInOutCubic',
        })
    },
  },
}
